import { useExperimentalFeature } from "@istari-frontend/experimental-features";
import type { ReactNode } from "react";
import { Navigate } from "react-router";

import { routes } from "~/routes";

export function SystemsDashboardGuard({ children }: { children: ReactNode }) {
  // Availability, not the user's toggle: the route stays reachable for a user who has the redesign
  // switched off, so a link into the dashboard still works.
  const { available } = useExperimentalFeature("system-redesign");
  if (!available) {
    return <Navigate to={routes.Systems} replace />;
  }
  return <>{children}</>;
}
